import React, { useState, useRef } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import scoringService from '../../services/ScoringService';
import { v4 as uuidv4 } from 'uuid';

const ConversionShotAtGoal = (props) => {

    const { homeTeam, awayTeam, fixtureRoomId, startTeamId, homeTeamPlayers, awayTeamPlayers, realMarkerX, realMarkerY, videoTime, clipStartTime, half, onConversionResult, setShowMultipleSelectedButton, onCancelButtonClick } = props;

    const dropdownSelectPlayerRef = useRef(null);

    const [scoreErrorMessages, setScoreErrorMessages] = useState(null);
    const [errorInputIds, setErrorInputIds] = useState(null);
    const [selectedPlayer, setSelectedPlayer] = useState(undefined);

    const handleSuccessfulConversion = async () => {
        if (selectedPlayer == null) {
            setScoreErrorMessages([{ id: uuidv4(), text: "Please select a player" }]);
        } else {
            if (videoTime <= clipStartTime) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Conversion result must come after clip start" }]);
            } else {
                if (realMarkerX == null || realMarkerY == null) {
                    setScoreErrorMessages([{ id: uuidv4(), text: "Please select coordinates" }]);
                } else {
                    await scoringService.addConversionKick(fixtureRoomId, startTeamId, clipStartTime, videoTime, 1, realMarkerX, realMarkerY, selectedPlayer, 1, [{ key: 41, value: 1 }], half, true, selectedPlayer.shirtNumber);
                    await setShowMultipleSelectedButton(true);
                    onConversionResult(null)
                }
            }
        }
    }

    const handleUnsuccessfulConversion = async () => {
        if (selectedPlayer == null) {
            setScoreErrorMessages([{ id: uuidv4(), text: "Please select a player" }]);
        } else {
            if (videoTime <= clipStartTime) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Conversion result must come after clip start" }]);
            } else {
                if (realMarkerX == null || realMarkerY == null) {
                    setScoreErrorMessages([{ id: uuidv4(), text: "Please select coordinates" }]);
                } else {
                    await scoringService.addConversionKick(fixtureRoomId, startTeamId, clipStartTime, videoTime, 1, realMarkerX, realMarkerY, selectedPlayer, -1, [{ key: 41, value: 1 }], half, false, selectedPlayer.shirtNumber);
                    await setShowMultipleSelectedButton(true);
                    onConversionResult(null)
                }
            }
        }
    }

    const getScoreErrorMessageSpan = () => {
        if (scoreErrorMessages && scoreErrorMessages.length > 0) {

            let result = [];

            for (let i = 0; i < scoreErrorMessages.length; i++) {
                let current = scoreErrorMessages[i];
                result.push(
                    <Alert key={current.id} variant="danger" className="text-center my-1" onClose={() => {
                        setScoreErrorMessages(scoreErrorMessages && scoreErrorMessages.length > 0 ? scoreErrorMessages.filter((x) => x.id != current.id) : null);
                        setErrorInputIds(errorInputIds && errorInputIds.length > 0 ? errorInputIds.filter((x) => x != current.id) : null);
                    }} dismissible>
                        <span>{current.text}</span>
                    </Alert>);
            }

            return <div className="mb-1" style={{ maxHeight: '240px', overflowY: 'scroll' }}>{result}</div>;
        }
    }

    const scoreErrorMessageSpan = getScoreErrorMessageSpan();

    return <>

        <div className="col-md-12 text-center">
            <h3> Shot at Goal Conversion</h3>

            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Team: &nbsp; </b></span>
                        <span className="py-1">{startTeamId == homeTeam.id ? homeTeam.name : awayTeam.name }</span>
                    </div>
                </Col>
            </Row>
            <Row className="pt-2">
                <Col>
                    <div className="d-flex">
                        <span className="py-1"><b>Select Penalty Kicker:</b></span>
                        <Form.Control as="select"
                            size="sm"
                            ref={dropdownSelectPlayerRef}
                            value={selectedPlayer}
                            onChange={(event) => { setSelectedPlayer(event.target.value) }}
                            className="ml-1"
                            style={{ width: '175px' }}
                            autoFocus
                        >
                            <option key={1}>Please select kicker...</option>
                            {startTeamId == homeTeam.id ?
                                homeTeamPlayers && homeTeamPlayers.map(x => {
                                    return <option key={x.position} value={x.shirtNumber}>{x.key}</option>
                                })
                                :
                                awayTeamPlayers && awayTeamPlayers.map(x => {
                                    return <option key={x.position} value={x.shirtNumber}>{x.key}</option>
                                })
                            }
                        </Form.Control>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Category: &nbsp; </b></span>
                        <span className="py-1">Place Kick</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Location: &nbsp; </b></span>
                        <span className="py-1">x: {Math.round(realMarkerX)}m y: {Math.round(realMarkerY)}m</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="danger"
                            onClick={async (e) => {
                                await onCancelButtonClick(e);
                            }}>Cancel</Button>
                    </div>
                </Col>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="danger"
                            onClick={async () => {
                                await handleUnsuccessfulConversion(realMarkerX, realMarkerY);
                            }}>Conversion Miss</Button>
                    </div>
                </Col>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="success"
                            onClick={async () => {
                                await handleSuccessfulConversion(realMarkerX, realMarkerY);
                            }}>Conversion Success</Button>
                    </div>
                </Col>
            </Row>
        </div>
        {scoreErrorMessageSpan}
    </>;
}

export default ConversionShotAtGoal;